/* eslint-disable */

import { useEffect, useState } from 'react';
import { Image, Spinner } from 'react-bootstrap';
import { getImageSize } from 'polotno/utils/image';
import {
    useDeleteAssetMutation,
    useLazyGetUploadedAssetsQuery,
} from '../../../store/api/editor.api';
import InfiniteScroll from 'react-infinite-scroll-component';
import Masonry from 'react-masonry-css';
import { motion } from 'framer-motion';
import { displaySuccessToast } from '../../../utils/ToastUtils';
import { unstable_registerNextDomDrop } from 'polotno/config';
import { getActiveBrand } from '../../../store/selector/brand.selector';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import {
    getAssets,
    getAssetsPage,
    getAssetshasNext,
} from '../../../store/selector/assets.selector';
import { DeleteAsset } from '../../../store/slice/assets.slice';
import { fetchMoreAssets } from '../../../utils/assets.utils';
import { getDesignElements } from '../../../store/selector/brand-elements.selector';

const CustomImagePallett = ({ store }: { store: any }) => {
    const dispatch = useAppDispatch();
    const activeBrand = useAppSelector(getActiveBrand);
    const designElementsData = useAppSelector(getDesignElements);
    const uploadedAssets = useAppSelector(getAssets);
    const assetsHasNext = useAppSelector(getAssetshasNext);
    const assetsPage = useAppSelector(getAssetsPage);
    const [fetchUploadedAssets] = useLazyGetUploadedAssetsQuery();
    const [deleteAsset] = useDeleteAssetMutation();

    const [deletingIndex, setDeletingIndex] = useState(null);

    const fetchMoreData = async () => {
        await fetchMoreAssets(
            activeBrand,
            assetsHasNext,
            fetchUploadedAssets,
            assetsPage,
            dispatch,
        );
    };

    const handleDeleteAsset = async (id: number, event: any) => {
        event.stopPropagation();
        event.preventDefault();
        try {
            await deleteAsset(id);
            dispatch(DeleteAsset(id));
            displaySuccessToast('Deleted Successfully');
        } catch (error) {
            console.error('Error deleting asset:', error);
        } finally {
            setDeletingIndex(null);
        }
    };

    const loadImage = async (imageURL: string) => {
        const { width, height } = await getImageSize(imageURL);
        const element = store.selectedElements[0];
        if (!element?.type) {
            store.activePage.addElement({
                type: 'image',
                src: imageURL,
                width: 200,
                height: 200,
                x: store.width / 2 - width / 2,
                y: store.height / 2 - height / 2,
            });
        } else {
            try {
                if (element?.type === 'image') {
                    store.selectedElements[0].set({ src: imageURL });
                } else if (element?.type === 'svg') {
                    store.selectedElements[0].set({ maskSrc: imageURL });
                } else {
                    store.activePage.addElement({
                        type: 'image',
                        src: imageURL,
                        width: 200,
                        height: 200,
                        x: store.width / 2 - width / 2,
                        y: store.height / 2 - height / 2,
                    });
                }
            } catch (error) {}
        }
    };

    useEffect(() => {
        const selected = store.selectedElements[0];
        if (selected) {
        }
    }, [store.selectedElements, store]);

    return (
        <div className="addFavourite-content">
            {designElementsData && designElementsData.logo && (
                <>
                    <div>
                        <div
                            style={{
                                paddingLeft: '10px',
                                fontSize: '17px',
                                fontWeight: '600',
                                cursor: 'pointer',
                            }}
                        >
                            Logo
                        </div>
                        <div className="p-2">
                            <div className="uploadedLogo">
                                <motion.div
                                    initial={{ scale: 0.8, opacity: 0 }}
                                    animate={{ scale: 1, opacity: 1 }}
                                    exit={{ scale: 0.8, opacity: 0 }}
                                    transition={{ duration: 0.5 }}
                                    className="m-0"
                                    onClick={() => {
                                        loadImage(
                                            designElementsData.logo ? designElementsData.logo : '',
                                        );
                                    }}
                                >
                                    <div className="p-2  image-delete">
                                        <Image
                                            src={designElementsData.logo}
                                            fluid
                                            rounded
                                            className="border border-grey"
                                            style={{ cursor: 'pointer' }}
                                            crossOrigin="anonymous"
                                            onDrag={() => {
                                                unstable_registerNextDomDrop((pos, element) => {
                                                    if (element && element.type === 'image') {
                                                        element.set({
                                                            src: designElementsData.logo,
                                                        });
                                                    } else if (element && element.type === 'svg') {
                                                        element.set({
                                                            maskSrc: designElementsData.logo,
                                                        });
                                                    } else {
                                                        store.activePage.addElement({
                                                            type: 'image',
                                                            src: designElementsData.logo,
                                                            x: pos.x,
                                                            y: pos.y,
                                                            width: 100,
                                                            height: 100,
                                                        });
                                                    }
                                                });
                                            }}
                                            onDragEnd={() => {
                                                unstable_registerNextDomDrop(null);
                                            }}
                                        />
                                    </div>
                                </motion.div>
                            </div>
                        </div>
                    </div>
                    <hr className="m-2" />
                </>
            )}
            <div>
                <div
                    style={{
                        paddingLeft: '10px',
                        fontSize: '17px',
                        fontWeight: '600',
                        cursor: 'pointer',
                    }}
                >
                    Assets
                </div>
                <InfiniteScroll
                    dataLength={uploadedAssets.length || 1}
                    next={fetchMoreData}
                    hasMore={assetsHasNext}
                    loader={
                        <div
                            className="w-100 d-flex mb-4 justify-content-center align-item-center"
                            style={{ padding: '24px', height: '180px' }}
                        >
                            <Spinner
                                as="span"
                                className="mr-1 pe-none"
                                role="status"
                                aria-hidden="true"
                                animation="border"
                                style={{
                                    marginTop: '40px',
                                    width: '48px',
                                    height: '48px',
                                    color: '#967AA7',
                                    background: 'transparent',
                                }}
                            />
                        </div>
                    }
                    height={window.innerHeight}
                    endMessage={
                        <p style={{ textAlign: 'center' }}>
                            <b>Yay! You have seen it all</b>
                        </p>
                    }
                    className=""
                >
                    <Masonry
                        breakpointCols={3}
                        className="pixii-grid m-1"
                        columnClassName="pixii-grid_column_assets"
                    >
                        {uploadedAssets &&
                            uploadedAssets.map((image, index) => (
                                <div key={index}>
                                    <motion.div
                                        key={index}
                                        initial={{ scale: 0.8, opacity: 0 }}
                                        animate={{ scale: 1, opacity: 1 }}
                                        exit={{ scale: 0.8, opacity: 0 }}
                                        transition={{ duration: 0.5 }}
                                        className="m-0"
                                        onClick={() => {
                                            loadImage(image.assets);
                                        }}
                                    >
                                        {deletingIndex === image.id ? (
                                            // Show loader while deleting
                                            <div>Loading...</div>
                                        ) : (
                                            <div className="p-2  image-delete">
                                                <Image
                                                    src={image.assets}
                                                    fluid
                                                    rounded
                                                    className="border border-grey"
                                                    style={{ cursor: 'pointer' }}
                                                    crossOrigin="anonymous"
                                                    onDrag={() => {
                                                        unstable_registerNextDomDrop(
                                                            (pos, element) => {
                                                                if (
                                                                    element &&
                                                                    element.type === 'image'
                                                                ) {
                                                                    element.set({
                                                                        src: image.assets,
                                                                    });
                                                                } else if (
                                                                    element &&
                                                                    element.type === 'svg'
                                                                ) {
                                                                    element.set({
                                                                        maskSrc: image.assets,
                                                                    });
                                                                } else {
                                                                    store.activePage.addElement({
                                                                        type: 'image',
                                                                        src: image.assets,
                                                                        x: pos.x,
                                                                        y: pos.y,
                                                                        width: 100,
                                                                        height: 100,
                                                                    });
                                                                }
                                                            },
                                                        );
                                                    }}
                                                    onDragEnd={() => {
                                                        unstable_registerNextDomDrop(null);
                                                    }}
                                                />
                                                <button
                                                    className="iconbtn iconbtn-transparent"
                                                    onClick={(event) =>
                                                        handleDeleteAsset(image.id, event)
                                                    }
                                                >
                                                    <i className="ph-bold ph-prohibit-inset lg"></i>
                                                </button>
                                            </div>
                                        )}
                                    </motion.div>
                                </div>
                            ))}
                    </Masonry>
                </InfiniteScroll>
            </div>
        </div>
    );
};

export default CustomImagePallett;
